import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "../locales/fr/common.json";
import en from "../locales/en/common.json";

const resources = {
  fr: { translation: fr },
  en: { translation: en },
};

i18n
  .use(LanguageDetector) // détecte localStorage, navigator.language, etc.
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr",
    supportedLngs: ["fr", "en"],
    detection: {
      // on aligne avec ta clé existante
      lookupLocalStorage: "site-lang",
      caches: ["localStorage"]
    },
    interpolation: { escapeValue: false }
  });

// Sync <html lang="..."> pour l’accessibilité/SEO
i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("lang", lng || "fr");
  }
});

export default i18n;
